import { Box, Icon, IconButton, TextField, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { IPropsBusinessPage } from '../Business';
import { businessService, finishRequest } from '../../../shared/services';
import { Button } from '../../../shared/components';

export const WhatsAppMessages: React.FC<IPropsBusinessPage> = ({ business, refetch }) => {
  const [messages, setMessages] = useState<string[]>(
    () => {
      try { return JSON.parse(business.predefinedMessages ?? '[]'); }
      catch { return []; }
    }
  );

  const { mutate: save, isLoading } = useMutation(
    () =>
      businessService.update({
        id: business.id,
        name: business.name,
        slug: business.slug,
        address: business.address,
        cnpj: business.cnpj,
        profilePicture: business.profilePicture,
        hideFromSearch: business.hideFromSearch,
        cardFeeDebit: business.cardFeeDebit,
        cardFeeCredit: business.cardFeeCredit,
        appointmentLeadTimeMinutes: business.appointmentLeadTimeMinutes,
        phone: business.phone,
        instagram: business.instagram,
        facebook: business.facebook,
        website: business.website,
        paymentMethods: business.paymentMethods,
        predefinedMessages: messages.length > 0 ? JSON.stringify(messages) : undefined,
      }),
    {
      onSuccess: () =>
        finishRequest('Mensagens salvas!', 'success', () => {
          refetch();
        }),
      onError: (error: Error) => finishRequest(error.message, 'error'),
    }
  );

  const handleChange = useCallback((index: number, value: string) => {
    setMessages((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  }, []);

  const handleRemove = useCallback((index: number) => {
    setMessages((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleAdd = useCallback(() => {
    setMessages((prev) => [...prev, '']);
  }, []);

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Mensagens Pré-definidas
      </Typography>
      <Typography variant='body2' color='text.secondary' mb={2}>
        Essas mensagens aparecerão como atalho ao clicar em um agendamento na agenda.
        Cada item abre o WhatsApp do cliente com a mensagem já preenchida.
      </Typography>

      {messages.map((msg, index) => (
        <Box key={index} display='flex' gap={1} mb={1.5} alignItems='flex-start'>
          <TextField
            value={msg}
            onChange={(e) => handleChange(index, e.target.value)}
            label={`Mensagem ${index + 1}`}
            placeholder='Ex: Olá, já estou pronto te esperando pro seu atendimento!'
            fullWidth
            multiline
            maxRows={3}
            size='small'
          />
          <IconButton
            color='error'
            onClick={() => handleRemove(index)}
            sx={{ mt: 0.5 }}
            size='small'
          >
            <Icon>delete</Icon>
          </IconButton>
        </Box>
      ))}

      <Button
        label='Adicionar Mensagem'
        variant='outlined'
        startIcon={<Icon>add</Icon>}
        onClick={handleAdd}
        sx={{ mb: 3 }}
      />

      <Box display='flex' justifyContent='end'>
        <Button
          label='Salvar'
          variant='contained'
          onClick={() => save()}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};
